/**
 * Filter of the «Ответственный» pickers of leads and deals on `sales`: the
 * project id. The list is then who may be responsible there: the owner and
 * the active people of the project (crm/db/12_projects.sql,
 * vv_responsible_candidates); the database refuses anyone else.
 */
export const RESPONSIBLE_IN_PROJECT = "responsible_in_project";
